(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
     
const WebiTimer = setInterval(countDown, 1000);
function countDown() {
  var countDownDate = new Date(document.querySelector('.wb_product_countdown').getAttribute('data-date')).getTime();
  var now = new Date().getTime();
  var distance = countDownDate - now;
  if (distance < 0 || isNaN(countDownDate)) {
    document.querySelector('.main_cdays .wb_cdays').textContent = "00";
    document.querySelector('.main_chours .wb_chours').textContent = "00";
    document.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
    document.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
  }
  else {  
    document.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
    document.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    document.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    document.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* GW featured-collection: native-cart Add to Cart + auto-slide. Dependency-free. */
  (function () {
    if (window.__gwFcInit) return;
    window.__gwFcInit = true;

    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------------- Add to Cart (uses the theme's own cart drawer) ---------------- */
    async function addToCart(root, form, btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      var label = btn.querySelector('[data-label]');
      var original = label.textContent;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      var fd = new FormData(form);
      var vid = currentId(form); if (vid) fd.set('id', vid);   /* variant picked with the theme's colour / size swatches */
      var cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        fd.append('sections', cartUI.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }

      var ok = false, handled = false;
      try {
        var res = await fetch(root.dataset.addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: fd
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
        ok = true;

        if (cartUI && typeof cartUI.renderContents === 'function' && data.sections) {
          try { cartUI.renderContents(data); handled = true; } catch (e) { /* fall through */ }
        }
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gw-featured', productVariantId: fd.get('id'), cartData: data });
          }
        } catch (e) { /* ignore */ }

        var cart = null;
        try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { /* ignore */ }
        ['cart:refresh', 'cart:updated', 'gw:cart:added'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart, item: data } }));
        });
        if (!handled) { window.location.href = root.dataset.cartUrl; return; }

        label.textContent = root.dataset.addedText || 'Added';
        btn.classList.add('is-added');
        var qi = form.querySelector('[data-gwfc-qinput]'); if (qi) { qi.value = 1; syncQty(form); }
      } catch (err) {
        label.textContent = (err && err.message ? err.message : 'Error').slice(0, 24);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.classList.remove('is-added'); label.textContent = original; }, ok ? 1800 : 2400);
      }
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-gwfc-form]');
      if (!form) return;
      var root = form.closest('[data-gwfc]');
      if (!root) return;
      e.preventDefault();
      addToCart(root, form, form.querySelector('[data-gwfc-add]'));
    });

    /* "Choose Options" -> open the theme's quick view if present, else go to the product page */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-gwfc-options]');
      if (!a) return;
      var qv = a.closest('.gwfc__card') && a.closest('.gwfc__card').querySelector('.wbquickv');
      if (qv) { e.preventDefault(); qv.click(); }
    });

    /* ---------------- quantity stepper ---------------- */
    function syncQty(form) {
      var i = form.querySelector('[data-gwfc-qinput]'); if (!i) return;
      var max = parseInt(form.dataset.max, 10); if (isNaN(max)) max = 99;
      var v = parseInt(i.value, 10) || 1;
      var m = form.querySelector('[data-gwfc-minus]'), p = form.querySelector('[data-gwfc-plus]');
      if (max <= 0) return;
      m.disabled = v <= 1; p.disabled = v >= max;
    }
    function setQty(form, delta) {
      var i = form.querySelector('[data-gwfc-qinput]'); if (!i) return;
      var max = parseInt(form.dataset.max, 10); if (isNaN(max)) max = 99;
      var v = parseInt(i.value, 10); if (isNaN(v)) v = 1;
      i.value = Math.max(1, Math.min(Math.max(max, 1), v + delta));
      syncQty(form);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-gwfc-plus],[data-gwfc-minus]');
      if (!b) return;
      var form = b.closest('[data-gwfc-form]'); if (!form) return;
      setQty(form, b.hasAttribute('data-gwfc-plus') ? 1 : -1);
    });
    document.addEventListener('input', function (e) {
      var i = e.target.closest && e.target.closest('[data-gwfc-qinput]');
      if (i) i.value = i.value.replace(/\D/g, '').slice(0, 3);
    });
    document.addEventListener('change', function (e) {
      var i = e.target.closest && e.target.closest('[data-gwfc-qinput]');
      if (i) setQty(i.closest('[data-gwfc-form]'), 0);
    });

    /* ---------------- follow the theme's colour / size swatches ---------------- */
    function handleize(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function variantInfo(form) {
      /* the theme's swatches are radio buttons (one group per option); join the checked ones = variant title */
      var card = form.closest('.gwfc__card');
      var radios = card ? card.querySelectorAll('input[type="radio"]:checked') : [];
      if (!radios.length) return null;
      var key = handleize(Array.prototype.map.call(radios, function (r) { return r.value; }).join(' / '));
      var hit = null;
      (form.dataset.vmax || '').split(',').forEach(function (p) {
        var a = p.split(':');
        if (a[0] === key) hit = { id: a[1], max: parseInt(a[2], 10) };
      });
      return hit;
    }
    function currentId(form) {
      var info = variantInfo(form);
      if (info) return info.id;
      var card = form.closest('.gwfc__card');
      var sel = card && card.querySelector('select[name="id"]');
      if (sel && sel.value) return sel.value;
      return (form.querySelector('input[name="id"]') || {}).value;
    }
    function syncVariant(form) {
      var info = variantInfo(form);
      var id = info ? info.id : currentId(form); if (!id) return;
      var max = info ? info.max : parseInt(form.dataset.max, 10);
      if (isNaN(max)) max = 99;
      form.dataset.max = max;
      var hid = form.querySelector('input[name="id"]'); if (hid) hid.value = id;
      var btn = form.querySelector('[data-gwfc-add]'), label = btn && btn.querySelector('[data-label]');
      var root = form.closest('[data-gwfc]');
      var i = form.querySelector('[data-gwfc-qinput]');
      if (btn && !btn.classList.contains('is-added') && !btn.classList.contains('is-loading')) {
        btn.disabled = max <= 0;
        if (label) label.textContent = max <= 0 ? (root.dataset.soldText || 'Sold out') : (root.dataset.addText || 'Add to Cart');
      }
      if (i) { i.disabled = max <= 0; var v = parseInt(i.value, 10) || 1; if (max > 0 && v > max) i.value = max; }
      syncQty(form);
    }
    function watchVariants(root) {
      root.querySelectorAll('[data-gwfc-form]').forEach(function (form) {
        if (form.__gwWatch) return; form.__gwWatch = true;
        var card = form.closest('.gwfc__card'); if (!card) return;
        var later = function () { setTimeout(function () { syncVariant(form); }, 60); setTimeout(function () { syncVariant(form); }, 400); };
        card.addEventListener('change', later);
        card.addEventListener('click', function (e) { if (e.target.closest('label, variant-radios, variant-selects')) later(); });
        var sel = card.querySelector('select[name="id"]');
        if (sel && 'MutationObserver' in window) new MutationObserver(later).observe(sel, { attributes: true, subtree: true, attributeFilter: ['selected', 'disabled'] });
        syncVariant(form);
      });
    }

    /* Move the "You save" line directly under each product title */

    /* Turn colour options into round dots. Handles "Color", "Colour", "COLOUR"; two-word names such as
       "BLACK GOLD" become a split dot; names that are not CSS colours stay as text pills. */
    function cssColor(v) {
      v = String(v || '').toLowerCase().trim();
      var joined = v.replace(/[^a-z]/g, '');
      if (joined === 'rosegold') return '#b76e79';
      if (window.CSS && CSS.supports('color', joined)) return joined;
      var w = v.split(/[^a-z]+/).filter(function (x) { return x && CSS.supports('color', x); });
      if (w.length === 1) return w[0];
      if (w.length > 1) return 'linear-gradient(135deg,' + w[0] + ' 50%,' + w[1] + ' 50%)';
      return '';
    }
    function dotify(root) {
      root.querySelectorAll('variant-radios fieldset').forEach(function (fs) {
        var r = fs.querySelector('input[type=radio]');
        if (!r || !/^colou?r$/i.test((r.name || '').trim())) return;
        fs.querySelectorAll('label.color-swatch').forEach(function (l) {
          if (l.classList.contains('gwfc-dot') || l.dataset.gwfcTxt) return;
          var val = l.getAttribute('data-val') || l.textContent;
          var c = cssColor(val);
          if (!c) { l.dataset.gwfcTxt = '1'; return; }
          l.classList.add('gwfc-dot');
          l.style.background = c;
          l.title = val; l.setAttribute('aria-label', val); l.textContent = '';
        });
      });
    }

    function placeNotes(root) {
      root.querySelectorAll('.gwfc__card').forEach(function (card) {
        var note = card.querySelector('[data-gwfc-note]');
        if (!note || note.__moved) return;
        var h = card.querySelector('.card__heading, .product-title');
        if (!h) { note.style.display = 'block'; return; }   /* no title found: keep the note in the footer */
        note.__moved = true;
        note.classList.add('is-moved');
        var anchor = h.closest('h1,h2,h3,h4,h5,h6,.card__heading') || h;
        anchor.parentNode.insertBefore(note, anchor.nextSibling);
        note.style.display = 'block';
        card.querySelectorAll('[data-gwfc-form]').forEach(syncQty);
      });
    }

    /* ---------------- Auto-slide (any breakpoint where the row is scrollable) ---------------- */
    function setup(root) {
      if (root.__gwFc || root.dataset.autoplay !== 'true' || reduce) return;
      var list = root.querySelector('ul.slider');
      if (!list) return;
      root.__gwFc = true;

      var interval = Math.max(2000, parseInt(root.dataset.interval, 10) || 3000);
      var timer = null, resumeTimer = null, visible = false, paused = false;

      function scrollable() { return list.scrollWidth > list.clientWidth + 8; }
      function step() {
        if (!scrollable() || paused || !visible || document.hidden) return;
        var slide = list.querySelector('.slider__slide');
        if (!slide) return;
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        var w = slide.offsetWidth + gap;
        var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 8;
        list.scrollTo({ left: atEnd ? 0 : list.scrollLeft + w, behavior: 'smooth' });
      }
      function pauseTemp() {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 6000);
      }
      ['touchstart', 'pointerdown', 'wheel', 'focusin', 'mouseenter'].forEach(function (ev) {
        list.addEventListener(ev, pauseTemp, { passive: true });
      });
      root.querySelectorAll('.slider-button').forEach(function (b) { b.addEventListener('click', pauseTemp); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.25 }).observe(root);
      } else { visible = true; }

      timer = setInterval(step, interval);
    }

    function init() { document.querySelectorAll('[data-gwfc]').forEach(function (r) { placeNotes(r); dotify(r); watchVariants(r); setup(r); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-collection-showcase"] && !Shopify.designMode) return;
  try {
    
/* =========================================================================
   GW COLLECTION SHOWCASE – behaviour (custom element, ~no dependencies)
   - qty stepper, variant switching, native-cart add, mobile carousel + autoplay
   ========================================================================= */
if (!customElements.get('gw-showcase')) {
  class GwShowcase extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gw-track]');
      if (!this.track) return;

      this.mq = window.matchMedia('(max-width: 749px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 4500);
      this.behavior = this.dataset.cartBehavior || 'auto';
      this.busy = new WeakSet();
      this.visible = true;
      this.interacting = false;
      this.userPaused = false;

      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      const passive = { signal: this.ac.signal, passive: true };

      /* delegated UI events */
      this.addEventListener('click', (e) => this.onClick(e), o);
      this.addEventListener('input', (e) => {
        const i = e.target.closest('[data-qinput]');
        if (i) i.value = i.value.replace(/\D/g, '').slice(0, 3);
      }, o);
      this.addEventListener('change', (e) => {
        const s = e.target.closest('[data-variant-select]');
        if (s) return this.onVariant(s);
        const i = e.target.closest('[data-qinput]');
        if (i) this.setQty(i.closest('form'), 0, true);
      }, o);
      this.addEventListener('submit', (e) => {
        const f = e.target.closest('[data-gw-form]');
        if (!f) return;
        e.preventDefault();
        this.add(f);
      }, o);

      /* carousel */
      this.thumb = this.querySelector('[data-thumb]');
      this.controls = this.querySelector('[data-controls]');
      this.track.addEventListener('scroll', () => this.queueProgress(), passive);
      window.addEventListener('resize', () => this.queueProgress(), passive);
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((ev) =>
        this.track.addEventListener(ev, () => this.pauseTemp(), passive));
      this.mq.addEventListener('change', () => { this.queueProgress(); this.schedule(); }, o);
      document.addEventListener('visibilitychange', () => this.schedule(), o);

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((en) => { this.visible = en[0].isIntersecting; this.schedule(); }, { threshold: 0.25 });
        this.io.observe(this);
      }

      this.querySelectorAll('[data-gw-form]').forEach((f) => this.syncQty(f));
      this.queueProgress();
      this.schedule();
    }

    disconnectedCallback() {
      this.ac && this.ac.abort();
      this.io && this.io.disconnect();
      clearTimeout(this.t); clearTimeout(this.r);
    }

    /* ---------------- click routing ---------------- */
    onClick(e) {
      const t = e.target;
      let b;
      if ((b = t.closest('[data-plus]'))) return this.setQty(b.closest('form'), +1);
      if ((b = t.closest('[data-minus]'))) return this.setQty(b.closest('form'), -1);
      if (t.closest('[data-next]')) { this.pauseTemp(); return this.go(1); }
      if (t.closest('[data-prev]')) { this.pauseTemp(); return this.go(-1); }
      if ((b = t.closest('[data-playpause]'))) {
        this.userPaused = !this.userPaused;
        b.setAttribute('aria-pressed', String(this.userPaused));
        b.setAttribute('aria-label', this.userPaused ? 'Start auto-scroll' : 'Pause auto-scroll');
        clearTimeout(this.t);
        if (!this.userPaused) this.schedule();
      }
    }

    /* ---------------- quantity ---------------- */
    setQty(form, delta, fromInput) {
      if (!form) return;
      const input = form.querySelector('[data-qinput]');
      const max = parseInt(form.dataset.max, 10);
      const cap = isNaN(max) ? 99 : max;
      let v = parseInt(input.value, 10);
      if (isNaN(v)) v = 1;
      v = Math.max(1, Math.min(Math.max(cap, 1), v + delta));
      input.value = v;
      this.syncQty(form);
    }
    syncQty(form) {
      const input = form.querySelector('[data-qinput]');
      const v = parseInt(input.value, 10) || 1;
      const max = parseInt(form.dataset.max, 10);
      const cap = isNaN(max) ? 99 : max;
      const minus = form.querySelector('[data-minus]');
      const plus = form.querySelector('[data-plus]');
      if (cap <= 0) { minus.disabled = plus.disabled = input.disabled = true; return; }
      input.disabled = false;
      minus.disabled = v <= 1;
      plus.disabled = v >= cap;
    }

    /* ---------------- variant switch ---------------- */
    onVariant(select) {
      const o = select.selectedOptions[0];
      if (!o) return;
      const d = o.dataset;
      const card = select.closest('[data-gw-card]');
      const form = select.closest('form');
      const ok = d.available === 'true';

      card.querySelector('[data-price]').textContent = d.price;
      const cmp = card.querySelector('[data-compare]');
      cmp.textContent = d.compare || '';
      cmp.hidden = !d.compare;

      const pill = card.querySelector('[data-pill]');
      if (pill) pill.hidden = ok;
      const off = card.querySelector('[data-off]');
      if (off) { off.textContent = d.pct + '% OFF'; off.hidden = !(+d.pct > 0) || off.dataset.disabled === 'true'; }

      form.dataset.max = d.max;
      const btn = form.querySelector('[data-add]');
      btn.disabled = !ok;
      btn.querySelector('[data-label]').textContent = ok ? this.dataset.addText : this.dataset.soldText;
      form.querySelector('[data-qinput]').value = 1;
      this.syncQty(form);
    }

    /* ---------------- add to cart (native theme cart) ---------------- */
    async add(form) {
      const btn = form.querySelector('[data-add]');
      if (!btn || btn.disabled || this.busy.has(form)) return;
      this.busy.add(form);
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      const label = btn.querySelector('[data-label]');
      const original = label.textContent;
      const fd = new FormData(form);
      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      /* Dawn-style: ask Shopify to return the re-rendered cart sections in the same request */
      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        fd.append('sections', cartUI.getSectionsToRender().map((s) => s.id).join(','));
        fd.append('sections_url', window.location.pathname);
      }

      let ok = false;
      try {
        const res = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: fd
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        ok = true;
        await this.afterAdd(data, cartUI, fd);
        label.textContent = this.dataset.addedText;
        btn.classList.add('is-added');
      } catch (err) {
        label.textContent = (err && err.message ? err.message : 'Error').slice(0, 28);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        setTimeout(() => {
          btn.classList.remove('is-added');
          label.textContent = original;
          this.busy.delete(form);
        }, ok ? 1800 : 2400);
      }
    }

    async afterAdd(data, cartUI, fd) {
      let handled = false;

      /* 1) Native Dawn cart drawer / notification */
      if (cartUI && typeof cartUI.renderContents === 'function' && data.sections) {
        try { cartUI.renderContents(data); handled = true; } catch (e) { /* fall through */ }
      }
      /* Dawn pub/sub so cart-items / icon bubble stay in sync */
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gw-showcase', productVariantId: fd.get('id'), cartData: data });
        }
      } catch (e) { /* ignore */ }

      /* 2) Generic themes: broadcast standard events + refresh count bubbles */
      let cart = null;
      try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { /* ignore */ }
      ['cart:refresh', 'cart:updated', 'gw:cart:added'].forEach((n) =>
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart, item: data } })));
      if (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count], .cart-count, .cart-count-bubble, #cart-icon-bubble .cart-count')
          .forEach((el) => { if (!el.children.length || el.matches('span')) el.textContent = cart.item_count; });
      }

      /* 3) Behaviour settings */
      if (this.behavior === 'redirect') { window.location.href = this.dataset.cartUrl; return; }
      const sel = this.dataset.openSelector;
      if (!handled && sel) {
        const opener = document.querySelector(sel);
        if (opener) { opener.click(); handled = true; }
      }
      /* 4) Last resort (theme has no cart UI at all): small toast with a View-cart link */
      if (!handled && this.behavior !== 'silent') this.toast();
    }

    toast() {
      if (!this.toastEl) {
        this.toastEl = document.createElement('div');
        this.toastEl.className = 'gw-sc__toast';
        this.toastEl.setAttribute('role', 'status');
        this.toastEl.innerHTML = '<span></span><a></a>';
        this.appendChild(this.toastEl);
      }
      this.toastEl.firstChild.textContent = this.dataset.toastText;
      const a = this.toastEl.querySelector('a');
      a.textContent = this.dataset.toastLink;
      a.href = this.dataset.cartUrl;
      this.toastEl.classList.add('is-on');
      clearTimeout(this.tt);
      this.tt = setTimeout(() => this.toastEl.classList.remove('is-on'), 3500);
    }

    /* ---------------- carousel ---------------- */
    step() {
      const it = this.track.querySelector('.gw-sc__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return it ? it.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    }
    go(dir) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      let x = t.scrollLeft + dir * this.step();
      if (dir > 0 && t.scrollLeft >= max - 4) x = 0;          // loop forward
      else if (dir < 0 && t.scrollLeft <= 4) x = max;         // loop backward
      t.scrollTo({ left: Math.max(0, Math.min(max, x)), behavior: this.reduce.matches ? 'auto' : 'smooth' });
    }
    queueProgress() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        const t = this.track;
        if (!this.thumb || !t.scrollWidth) return;
        const w = Math.min(100, (t.clientWidth / t.scrollWidth) * 100);
        const l = (t.scrollLeft / t.scrollWidth) * 100;
        this.thumb.style.width = w + '%';
        this.thumb.style.left = Math.min(100 - w, l) + '%';
        if (this.controls) this.controls.classList.toggle('is-static', t.scrollWidth <= t.clientWidth + 2);
        if (this.mq.matches) {   // highlight the card nearest the left edge (mobile)
          const tl = t.getBoundingClientRect().left + parseFloat(getComputedStyle(t).paddingLeft || 0);
          let best = null, bd = 1e9;
          t.querySelectorAll('.gw-sc__card').forEach((c) => { const d = Math.abs(c.getBoundingClientRect().left - tl); c.classList.remove('is-active'); if (d < bd) { bd = d; best = c; } });
          if (best) best.classList.add('is-active');
        }
      });
    }

    /* ---------------- autoplay (mobile only, smart pause/resume) ---------------- */
    canPlay() {
      return this.autoplay && this.mq.matches && !this.reduce.matches && this.visible &&
        !document.hidden && !this.userPaused && !this.interacting &&
        this.track.scrollWidth > this.track.clientWidth + 2;
    }
    schedule() {
      clearTimeout(this.t);
      if (!this.canPlay()) return;
      this.t = setTimeout(() => {
        if (this.canPlay()) this.go(1);
        this.schedule();
      }, this.interval);
    }
    pauseTemp() {
      if (!this.autoplay) return;
      this.interacting = true;
      clearTimeout(this.t); clearTimeout(this.r);
      this.r = setTimeout(() => { this.interacting = false; this.schedule(); }, 6000); // resume after 6s idle
    }
  }
  customElements.define('gw-showcase', GwShowcase);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-shop-by-collection"] && !Shopify.designMode) return;
  try {
    
/* GW SHOP BY COLLECTION – mobile arrows, progress bar and smart auto-slide */
if (!customElements.get('gw-shopcol')) {
  class GwShopCol extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gx-track]');
      if (!this.track) return;
      this.thumb = this.querySelector('[data-gx-thumb]');
      this.controls = this.querySelector('[data-gx-controls]');
      this.mq = window.matchMedia('(max-width: 749px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 3500);
      this.visible = true;
      this.interacting = false;
      this.userPaused = false;

      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      const p = { signal: this.ac.signal, passive: true };

      this.track.addEventListener('scroll', () => this.paint(), p);
      window.addEventListener('resize', () => this.paint(), p);
      /* any touch / wheel / key / focus pauses, resumes after 6s idle */
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((ev) =>
        this.track.addEventListener(ev, () => this.pauseTemp(), p));
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-gx-next]')) { this.pauseTemp(); this.go(1, false); }
        else if (e.target.closest('[data-gx-prev]')) { this.pauseTemp(); this.go(-1, false); }
        else {
          const b = e.target.closest('[data-gx-pp]');
          if (!b) return;
          this.userPaused = !this.userPaused;
          b.setAttribute('aria-pressed', String(this.userPaused));
          b.setAttribute('aria-label', this.userPaused ? 'Start auto-slide' : 'Pause auto-slide');
          clearTimeout(this.t);
          if (!this.userPaused) this.schedule();
        }
      }, o);
      this.mq.addEventListener('change', () => { this.paint(); this.schedule(); }, o);
      document.addEventListener('visibilitychange', () => this.schedule(), o);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((en) => { this.visible = en[0].isIntersecting; this.schedule(); }, { threshold: 0.25 });
        this.io.observe(this);
      }
      this.paint();
      this.schedule();
    }
    disconnectedCallback() {
      this.ac && this.ac.abort();
      this.io && this.io.disconnect();
      clearTimeout(this.t); clearTimeout(this.r);
    }
    /* one column step for auto-slide, 80% of the width for arrows */
    step(auto) {
      const it = this.track.querySelector('.gw-cx__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      if (auto && it) return it.getBoundingClientRect().width + gap;
      return this.track.clientWidth * 0.8;
    }
    go(dir, auto) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      let x = t.scrollLeft + dir * this.step(auto);
      if (dir > 0 && t.scrollLeft >= max - 4) x = 0;      /* loop to start */
      else if (dir < 0 && t.scrollLeft <= 4) x = max;
      t.scrollTo({ left: Math.max(0, Math.min(max, x)), behavior: this.reduce.matches ? 'auto' : 'smooth' });
    }
    canPlay() {
      return this.autoplay && this.mq.matches && !this.reduce.matches && this.visible &&
        !document.hidden && !this.userPaused && !this.interacting &&
        this.track.scrollWidth > this.track.clientWidth + 2;
    }
    schedule() {
      clearTimeout(this.t);
      if (!this.canPlay()) return;
      this.t = setTimeout(() => {
        if (this.canPlay()) this.go(1, true);
        this.schedule();
      }, this.interval);
    }
    pauseTemp() {
      if (!this.autoplay) return;
      this.interacting = true;
      clearTimeout(this.t); clearTimeout(this.r);
      this.r = setTimeout(() => { this.interacting = false; this.schedule(); }, 6000);
    }
    paint() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        const t = this.track;
        if (!this.thumb || !t.scrollWidth) return;
        const w = Math.min(100, (t.clientWidth / t.scrollWidth) * 100);
        this.thumb.style.width = w + '%';
        this.thumb.style.left = Math.min(100 - w, (t.scrollLeft / t.scrollWidth) * 100) + '%';
        if (this.controls) this.controls.classList.toggle('is-static', t.scrollWidth <= t.clientWidth + 2);
      });
    }
  }
  customElements.define('gw-shopcol', GwShopCol);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
